import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoArticulo from "../articulo/InfoArticulo";
const Footer = lazy(() => import('../footer/Footer'));
function Articulo(props) {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Ponte al día con Hyundai. Revisa las noticias relevantes de nuestra marca, no te pierdas de ninguna"
        />
        <meta name="keywords" content="Hyundai, noticias, actualidad" />
        <title>Noticias Hyundai</title>
      </Helmet>
      <Menu />
      <InfoArticulo url={props.match.url} />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Articulo;